<template>
    <div v-loading="loading" element-loading-text="" element-loading-spinner="el-icon-loading">
        <iframe
            v-if="decodedUrl"
            :src="decodedUrl"
            @load="iframeLoaded"
            @error="iframeError"
            class="iframe-container"></iframe>
        <div v-else class="empty-tip">请选择导航链接</div>
    </div>
</template>

<script>
import bus from '../../../components/common/bus';
export default {
    data() {
        return {
            currentUrl: '',
            loading: false, // 初始状态不显示loading
        };
    },
    computed: {
        decodedUrl() {
            return this.currentUrl ? decodeURIComponent(this.currentUrl) : '';
        }
    },
    watch: {
        '$route.query.url': {
            immediate: true,
            handler(newUrl) {
                if (newUrl) {
                    this.currentUrl = newUrl;
                    this.loading = true; // URL更新时立即显示loading
                    console.log('URL updated:', this.decodedUrl);
                }
            }
        }
    },
    mounted() {
        // 初始化处理
        if (this.$route.query.url) {
            this.currentUrl = this.$route.query.url;
            this.loading = true; // 初始加载时显示loading
        }
    },
    methods: {
        // iframe加载完成时隐藏loading
        iframeLoaded() {
            this.loading = false;
            console.log('iframe loaded successfully');
        },
        // iframe加载错误时也隐藏loading
        iframeError() {
            this.loading = false;
            console.error('iframe loading failed');
            this.$message.error('页面加载失败，请检查链接');
        }
    }
};
</script>
<style scoped>
.iframe-container {
    width: 100%;
    height: calc(100vh - 60px); /* 根据实际布局调整 */
    border: 0;
    display: block;
}
.empty-tip {
    padding: 20px;
    text-align: center;
    color: #888;
}
</style>